import { Button, Checkbox, Form, Input, Radio, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
	requestCreateBizAccount,
	requestLocation,
} from '../../store/login/actions';
import {
	getBizErrors,
	getLocation,
	getUserProfile,
} from '../../store/login/selectors';
import { locationPayload } from '../../store/login/types';
import {useTranslation} from "react-i18next";
import { getPartnerBannerImages, isWebView } from '../../utilities/webview';
import PartnerBannerCarousel from '../../components/PartnerBannerCarousel';
import TermsDrawer from '../../components/TermsDrawer';

const TERM_SERVICE_URL = 'https://swift247.vn/terms-conditions-cargo-direct-swift247/';
const PRIVACY_POLICY_URL = 'https://swift247.vn/chinh-sach-bao-mat-swift247/';

const initialMsgState = {
	company_name: '',
	email: '',
	tax_number: '',
	company_phone: '',
	address_full: '',
	company_representative: '',
	gender: '',
	province: '',
	term: '',
};

const initialForm = {
	company_name: '',
	email: '',
	tax_number: '',
	company_phone: '',
	company_representative: '',
	gender: 'Nam',
	birth: '',
	country: '0',
	province: null,
	district: '',
	village: '',
	address: '',
	address_full: '',
	term: true,
};

const CreateNewBusinessAccount = () => {
	const [form] = Form.useForm();
	const [msg, setMsg] = useState(initialMsgState);
	const [isDisabledButton, setIsDisabledButton] = useState(true);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const locations = useSelector(getLocation);
	const profile = useSelector(getUserProfile);
	const bizErrors = useSelector(getBizErrors);
  const {t, i18n}= useTranslation();
	const webView = isWebView();
	const [termDrawerOpen, setTermDrawerOpen] = useState(false);
	const [privacyDrawerOpen, setPrivacyDrawerOpen] = useState(false);

	const handleTermLinkClick = (openDrawer: (open: boolean) => void) => (e: React.MouseEvent<HTMLAnchorElement>) => {
		if (!webView) return;
		e.preventDefault();
		openDrawer(true);
	};

	// Partner banner (e.g. Vikki) replaces the "Welcome to Swift247!" title when
	// configured via theme_config.backgroundImagesUrl — falls back to the title
	// when the partner hasn't set one. backgroundImagesUrl is keyed by language
	// (en/vi), so re-read it whenever the active language changes.
	const [bannerImages, setBannerImages] = useState<string[]>(() => getPartnerBannerImages(i18n.language));

	useEffect(() => {
		setBannerImages(getPartnerBannerImages(i18n.language));
	}, [i18n.language]);

	useEffect(() => {
		if (bizErrors && Object.values(bizErrors).length) {
			const keys = Object.keys(bizErrors);
			keys.map((item) => {
				setMsg((prevState) => ({
					...prevState,
					[item]:
						bizErrors[item][0] === 'VALIDATE.UNIQUE_EMAIL'
							? 'Email đã tồn tại trong hệ thống, vui lòng sử dụng địa chỉ email khác.'
							: bizErrors[item][0],
				}));
			});
		}
	}, [bizErrors]);

	useEffect(() => {
		console.log('Here useEffect profile');
		if (profile) {
			console.log('Navigate to /enter-otp');
			// create biz account success
			// redirect to OTP
			navigate('/enter-otp');
		}
	}, [profile]);

	const validateForm = () => {
		const {
			email,
			term,
			company_phone,
			company_name,
			company_representative,
			tax_number,
			province,
		} = form.getFieldsValue();
		let isValid = true;
		setMsg(initialMsgState);
		setIsDisabledButton(false);

		if (!company_representative || !company_representative.length) {
			setMsg((prevState) => ({
				...prevState,
				company_representative: 'Vui lòng nhập người đại diện',
			}));
			isValid = false;
		}

		if (!company_name || !company_name.length) {
			setMsg((prevState) => ({
				...prevState,
        company_name: 'validation_required_company_name',
			}));
			isValid = false;
		} else {
			const name = company_name.replace(
				/[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/g,
				'',
			);
			form.setFieldsValue({ company_name: name });
		}

		if (!tax_number) {
			setMsg((prevState) => ({
				...prevState,
        tax_number: 'validation_required_tax_number',
			}));
			isValid = false;
		}

		if (!email || !email.length) {
			setMsg((prevState) => ({
				...prevState,
        email: 'validation_required_email',
			}));
			isValid = false;
			setIsDisabledButton(true);
		}

		if (!province || !province.length) {
			setMsg((prevState) => ({
				...prevState,
        province: 'validation_required_province',
			}));
			isValid = false;
		}

		if (
			email &&
			!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
				email,
			)
		) {
			setMsg((prevState) => ({
				...prevState,
        email: 'validation_email_pattern',
			}));
			isValid = false;
			setIsDisabledButton(true);
		}

		if (!company_phone || !company_phone.length) {
			setMsg((prevState) => ({
				...prevState,
				company_phone: 'Vui lòng nhập số điện thoại',
			}));
			isValid = false;
		} else if (company_phone && company_phone.length < 9) {
			setMsg((prevState) => ({
				...prevState,
        company_phone: 'validation_phone_length_min',
			}));
			isValid = false;
		} else if (company_phone && company_phone.length > 11) {
			setMsg((prevState) => ({
				...prevState,
        company_phone: 'validation_phone_length_max',
			}));
			isValid = false;
		}

		if (!term) {
			setMsg((prevState) => ({
				...prevState,
        term: 'validation_term_service',
			}));
			isValid = false;
			setIsDisabledButton(true);
		}
		return isValid;
	};

	const handleOnSubmit = () => {
		console.log('handleOnSubmit');
		if (validateForm()) {
			const formValue = form.getFieldsValue();
			//   default country as VietNam
			formValue.country = '0';
			delete formValue.term;
			dispatch(requestCreateBizAccount(formValue));
		}
	};

	useEffect(() => {
		dispatch(requestLocation({ locationType: 'province', id: '0' }));
	}, []);
	const { Option } = Select;

	return (
		<>
			{bannerImages.length ? (
				<PartnerBannerCarousel images={bannerImages} />
			) : (
				<div className="header-title">
					<div className="title">{t('global_welcome')}</div>
					<div className="subtitle">
		        {t('section_title_business_account_register')}
					</div>
				</div>
			)}
			<Form
				layout="vertical"
				onValuesChange={() => validateForm()}
				initialValues={initialForm}
				form={form}
				onFinish={() => handleOnSubmit()}
			>
				<Form.Item
          label={t('placeholder_company_name')}
          help={t(msg.company_name)}
					name="company_name"
				>
					<Input placeholder={t('placeholder_company_name')} autoFocus type="text" />
				</Form.Item>
				<Form.Item
          label={t('global_delegator')}
					name="gender"
					className="custom-form-horizontal align-items-baseline gap-4"
				>
					<Radio.Group className="radio-button-select">
						<Radio value={'Nam'}>{t('global_title_male')}</Radio>
						<Radio value={'Nu'}>{t('global_title_female')}</Radio>
					</Radio.Group>
				</Form.Item>
				<Form.Item
          help={t(msg.company_representative)}
					name="company_representative"
				>
          <Input placeholder={t('global_delegator')} />
				</Form.Item>
				<Form.Item
					label={t('global_tax_number')}
					help={t(msg.tax_number)}
					name="tax_number"
				>
					<Input placeholder={t('global_tax_number')} type="number" />
				</Form.Item>
				<Form.Item
          label={t('global_company_phone')}
          help={t(msg.company_phone)}
					name="company_phone"
				>
          <Input placeholder={t('global_company_phone')} />
				</Form.Item>
        <Form.Item label={t('global_email')} help={t(msg.email)} name="email">
          <Input placeholder={t('global_email')} />
				</Form.Item>

				<Form.Item
					label={t('input_label_province_city')}
					help={t(msg.province)}
					name="province"
				>
					<Select placeholder={t('input_label_province_city')}>
						{locations &&
							locations.province &&
							locations.province.map((item: locationPayload) => (
								<Option value={item.id} key={item.id}>
									{item.name}
								</Option>
							))}
					</Select>
				</Form.Item>
				<Form.Item
					label={t('address')}
					help={t(msg.address_full)}
					name="address_full"
				>
					<Input placeholder={t('address')} type="text" />
				</Form.Item>
        <Form.Item help={t(msg.term)} valuePropName="checked" name="term">
					<Checkbox>
            {t('authentication_message_term_service_1')}{' '}
						<a
							target={webView ? undefined : '_blank'}
							className="term-link"
							href={TERM_SERVICE_URL}
							onClick={handleTermLinkClick(setTermDrawerOpen)}
						>
              {t('authentication_message_term_service_2')}
						</a>{' '}
            {t('authentication_message_term_service_3')}{' '}
						<a
							target={webView ? undefined : '_blank'}
							className="term-link"
							href={PRIVACY_POLICY_URL}
							onClick={handleTermLinkClick(setPrivacyDrawerOpen)}
						>
              {t('authentication_message_term_service_4')}
						</a>
					</Checkbox>
				</Form.Item>
				<TermsDrawer href={TERM_SERVICE_URL} open={termDrawerOpen} onOpenChange={setTermDrawerOpen} title={t('authentication_message_term_service_2')} />
				<TermsDrawer href={PRIVACY_POLICY_URL} open={privacyDrawerOpen} onOpenChange={setPrivacyDrawerOpen} title={t('authentication_message_term_service_4')} />
				<Form.Item label="">
					<div className="d-flex gap-2">
						<Button
							htmlType="button"
							type="default"
							onClick={() => navigate('/')}
						>
              				{t('global_cancel')}
						</Button>
						<Button
							htmlType="submit"
							type="primary"
							disabled={isDisabledButton}
						>
              				{t('global_finish')}
						</Button>
					</div>
				</Form.Item>
			</Form>
		</>
	);
};

export default CreateNewBusinessAccount;
